// axios
import axios from 'axios'
import { apiBaseUrl } from '@/environment/environment';
import { logger } from '@/app/shared/services/app-logger/app-logger';
import AuthService from '@/app/shared/services/authentication/auth.service';
import store from '@/store/store.js';

const config = {
  baseURL: apiBaseUrl
};

const axiosWebApiInstance = axios.create(config);
const authService = new AuthService();

// Initialize MSAL for this auth service instance
const authInitPromise = authService.initialize();

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * @param {*} config
 */
const authInterceptor = async config => {
  if (config.baseURL === apiBaseUrl && !config.headers.Authorization) {
    // Wait for MSAL initialization before getting token
    await authInitPromise;
    const token = await authService.getWebApiToken();
    if (token === undefined) console.error('token is undefined');
    config.headers.Authorization = `Bearer ${token.accessToken}`;
  }

  return config
};

axiosWebApiInstance.interceptors.request.use(authInterceptor);

const selectedProjectInterceptor = config => {
  config.headers.selectedProjectId = store.state.projectId
  return config
};

axiosWebApiInstance.interceptors.request.use(selectedProjectInterceptor);

axiosWebApiInstance.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (typeof error.response !== 'undefined') {
      const originalRequest = error.config;
      if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        await authInitPromise;
        const token = await authService.getWebApiToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${token.accessToken}`;
        return axiosWebApiInstance(originalRequest);
      }
    }

    logger.error(error);
    return Promise.reject(error);
  }
);

export { axiosWebApiInstance };